// =====================================
//
//   企業用戶 認證 email Controller
//   Author: Gray
//   createtime: 2017 / 11 / 27
//
// =====================================

window.InifECMobileApp.controller("BusinessMemberMailIdentifyController", ['$scope', '$timeout', '$rootScope', '$stateParams', '$state', 'BusinessMemberService', '$InifECGA',
    function($scope, $timeout, $rootScope, $stateParams ,$state , BusinessMemberService, $InifECGA) {

        var finishApply = function() {

            if($scope.token) {

                BusinessMemberService.finishApply($scope.token).then(function(result) {
                    $timeout(function() {
                        $rootScope.$broadcast('OPEN_MAIL_IDENTIFY_MODAL', {});
                        $InifECGA.sendFinishApplyFBPixel();
                    });
                },function(error) {
                    $timeout(function() {
                        $state.go(window.STATES.HOME);
                        $rootScope.$broadcast('OPEN_ERROR_MESSAGE_MODAL', {
                            title: "無法認證您的 Email，請稍候再試"
                        });
                    })
                })
            }
        }

        var init = function() {
            finishApply();
        };

        /*==========================
            Events
        ==========================*/

        /*==========================
            Members
        ==========================*/
        $scope.token = $stateParams.token;

        /*==========================
             Methods
        ==========================*/

        /*==========================
            init
        ==========================*/
        init();
    }
]);